import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { WhatsappRevenuePage } from './WhatsappRevenuePage';

export const routes: FeatureRoute[] = [
  {
    path: 'whatsapp-revenue',
    element: (
      <RequireCapability anyOf={['subscriptions.manage']} what="WhatsApp revenue">
        <WhatsappRevenuePage />
      </RequireCapability>
    ),
  },
];
